module.exports = __webpack_public_path__ + "static/media/1.625a7da9.png";